import type MapView from "@arcgis/core/views/MapView";
import React, { useEffect, useState } from "react";
import { Segment } from "semantic-ui-react";

interface Props {
  view: MapView;
  visible: boolean;
  message: string;
}

const Tooltip = ({ view, visible, message }: Props) => {
  const { clientX, clientY } = useMousePosition();
  const [inMap, setInMap] = useState(true);

  useEffect(() => {
    view.on("pointer-enter", () => {
      //   console.warn("pointer-enter", event);
      setInMap(true);
    });
    view.on("pointer-leave", () => {
      // console.error("pointer-leave", event);
      setInMap(false);
    });
  }, []);

  //   console.log("Tooltip", { inMap, visible });

  if (!inMap || !visible || (clientX === 0 && clientY === 0)) {
    return null;
  }
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <Segment
        raised
        style={{
          fontWeight: "8pt",
          padding: ".5em",
          position: "absolute",
          left: clientX + 15,
          top: clientY + 15,
          maxWidth: "150px",
        }}
      >
        {message}
      </Segment>
    </div>
  );
};

const useMousePosition = () => {
  const [position, setPosition] = useState({
    clientX: 0,
    clientY: 0,
  });

  const updatePosition = (event) => {
    const { clientX, clientY } = event;

    setPosition({
      clientX,
      clientY,
    });
  };

  useEffect(() => {
    document.addEventListener("mousemove", updatePosition, false);
    document.addEventListener("mouseenter", updatePosition, false);

    return () => {
      document.removeEventListener("mousemove", updatePosition);
      document.removeEventListener("mouseenter", updatePosition);
    };
  }, []);

  return position;
};

export default Tooltip;
